import { render, staticRenderFns } from "./WifiInformation.vue?vue&type=template&id=6bf23744&scoped=true"
import script from "./WifiInformation.vue?vue&type=script&lang=js"
export * from "./WifiInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf23744",
  null
  
)

export default component.exports